











































































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { APagination } from './../../components'
import { AInput, AButton, AIcon, Ranger, NoResult, NoBinds, PaperItem, NetsTab } from '@/components'
import DownloadModal from './components/DownloadModal.vue'
import { paperList, paperDoc, otherAccounts, paperDocS2 } from './models/api'
import { loadFromLocal } from '@/utils/local'
import { getUrlParams } from '@/utils/urlUtils'
import TestJeyoo from './../../components/common/testOther/TestJeyoo.vue'
import TestZxxk from './../../components/common/testOther/TestZxxk.vue'
import { sa } from '@/utils/sa'

@Component({
  components: {
    AInput,
    AButton,
    AIcon,
    PaperItem,
    Ranger,
    DownloadModal,
    NoResult,
    NoBinds,
    APagination,
    TestJeyoo,
    TestZxxk,
    NetsTab
  }
})
export default class PaperList extends Vue {
  public paperId = ''
  public visible = false
  public testModal = false
  public netData = []
  public currentNet = this.nets[0][1]
  public currentSite = this.nets[0][0]
  public currentTitle = ''
  public contentData = []
  public page = 1
  public perPage = 10
  public sortWay = 'desc'
  public total = 0
  public sum = 0
  public noBind = false
  public jyeoo = {}
  public loading = false
  public currentPaper: any = {}
  public rn: string = ''
  public youDian = {}
  public currentUrl = ''
  public loadingModal = false
  public clean = false
  public typed = false // 是否为精排卷，默认 否 后端对应参数 1为 精
  public famousPaper = false // 是否为名校试卷

  /**
   * mounted
   */
  public mounted() {
    if (this.keyword) {
      this.currentTitle = this.keyword + ''
      // this.getList()
    }
    // this.getList()
    this.getOtherAccounts()
  }
  // computed
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get nets() {
    if (this.userInfo && this.userInfo.is_oto_account) {
      if (/^1\d{2}$/.test(this.subject.value)) {
        return [
          [6, '小学OTO'],
          [1, '17题库']
          // [2, '菁优网'],
          // [3, '学科网']
        ]
      }
      return [
        [1, '17题库']
        // [2, '菁优网'],
        // [3, '学科网']
      ]
    } else {
      return [
        [1, '17题库']
        // [2, '菁优网'],
        // [3, '学科网']
      ]
    }
  }
  public get keyword() {
    return this.$route.query.keyword
  }
  public get subject() {
    return this.$store.state.subject
  }
  public get siteData() {
    return this.$store.state.siteChoices
  }
  public get getFilters() {
    // console.log('change')
    return this.$store.state.filters
  }
  public get switchTemplate() {
    if (this.noBind) {
      return 3
    } else {
      if (this.contentData.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }
  public get userName() {
    return (
      loadFromLocal('net_username') ||
      (this.$store.state.user ? this.$store.state.user.name : '') ||
      ''
    )
  }
  public get xueke() {
    return this.$store.state.xuekeChoice
  }
  public get grades() {
    return this.$store.state.grades
  }
  private get user() {
    return this.$store.state.user
  }
  private get showExtra() {
    return this.userInfo && this.userInfo.is_inner_user
  }
  @Watch('subject', { immediate: true, deep: true })
  onSubjectChange(val, old) {
    if (old && val.value === old.value) return
    this.reset()
  }
  @Watch('getFilters', { deep: true })
  onFiltersChange(val, old) {
    if (old) {
      if (
        old.grade === val.grade &&
        old.paper_type === val.paper_type &&
        old.region_code === val.region_code &&
        old.year === val.year &&
        val.reset
      ) {
        return
      }
    }
    this.page = 1
    this.getList()
    // 埋点---筛选条件改变
    setTimeout(() => {
      sa.track('ContentRepository_Filter', {
        screenType: '试卷页面',
        modules: '试卷',
        grade: this.getFilters.grade,
        grade_name: this.getFilters.grade_name,
        province: this.getFilters.region,
        province_name: this.getFilters.region_name,
        year: this.getFilters.year,
        source: this.getFilters.paper_type,
        source_name: this.getFilters.paper_type_name,
        ContentRepository: this.currentSite,
        timeSequence: this.sortWay === 'desc' ? '降序' : '升序',
        ContentRepository_name: this.currentNet
      })
    }, 50)
  }
  @Watch('currentSite', { immediate: true, deep: true })
  onCursiteChange(val, old) {
    if (!old) return
    if (val === old) return
    this.page = 1
    console.log(3)
    this.getList()
  }
  // @Watch('visible')
  // onVisibleChange(val) {
  //   if (!val) {
  //     this.youDian = {}
  //   }
  // }
  @Watch('currentTitle')
  onCurrentTitleChange(val) {
    if (val === '') {
      console.log(4)
      this.page = 1
      this.getList()
    }
  }
  @Watch('user', { deep: true })
  onUserChange(val, old) {
    if (old && val && val.name === old.name) return
    this.page = 1
    this.getList()
    console.log(10)
  }
  public clearSearchInput() {
    this.currentTitle = ''
    this.page = 1
    this.getList()
  }
  public downloadInfoChange(val) {
    if (this.visible) {
      this.getPaperDoc(this.currentPaper.id, val)
    }
  }
  /**
   * trackDownload
   */
  public async trackDownload() {
    // tslint:disable-next-line:empty
    sa.track('ContentRepository_Download', {
      grade: this.getFilters.grade,
      grade_name: this.getFilters.grade_name,
      province: this.getFilters.region_code,
      province_name: this.getFilters.region_name,
      year: this.getFilters.year + '',
      source: this.getFilters.paper_type,
      source_name: this.getFilters.paper_type_name,
      ContentRepository: this.currentSite,
      ContentRepository_name: this.currentNet,
      subject_list: [this.subject.value + ''],
      action: '点击下载'
    })
  }
  /**
   * downloadFile
   */
  public async downloadFile(val) {
    // console.log(val)
    // this.getPaperDoc(this.currentPaper.id, val)
    this.trackDownload()
    if (this.currentUrl) {
      this.loadingModal = true
      let res = await paperDocS2({
        doc_src: (this.youDian as any).doc_src,
        site: this.currentSite
      })
      this.loadingModal = false
      if (res.code === 0) {
        sa.track('ContentRepository_Download', {
          action: '下载成功'
        })
        window.open(this.currentUrl + `&url=${res.data.doc_src}`)
      } else {
        this.$message.warning('下载地址不见了')
      }
      this.cancelModal(1)
    } else {
      this.$message.warning('下载地址不见了')
    }
  }
  public onTestCancel() {
    this.testModal = false
  }
  public jeyooLogin() {
    this.getList()
  }
  public async getOtherAccounts() {
    let { data } = await otherAccounts({})
    this.jyeoo = data
    this.$store.commit('SET_BINDACCOUNTS', data)
  }
  public reset() {
    this.$store.commit('SET_FILTERS', {
      grade: 0,
      paper_type: 0,
      region_code: 0,
      year: 0,
      reset: true,
      city: 0,
      district: 0,
      cityArray: [],
      districtArray: []
    })
    this.$store.commit('SET_RESET', true)
    this.clean = !this.clean
    this.currentNet = this.nets[0][1]
    this.currentSite = this.nets[0][0]
    this.currentTitle = ''
    this.contentData = []
    this.page = 1
  }
  /**
   * clickDownload
   */
  public clickDownload(val: any) {
    // console.log(val)
    this.currentPaper = val
    if (!loadFromLocal('net_username')) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    if (this.currentSite === 2) {
      this.visible = true
      // this.getPaperDoc(val.id)
    } else {
      this.getPaperDoc(val.id, val)
      this.trackDownload()
    }
  }
  /**
   * cancelModal
   */
  public cancelModal(val: any) {
    this.visible = false
    this.currentPaper = {}
  }
  /**
   * onSearch
   */
  public onSearch() {
    this.page = 1
    this.getList()
    // tslint:disable-next-line
    sa.track('ContentRepository_Search', {
      keyword: this.currentTitle
    })
  }
  public onPageChange(val) {
    this.page = val
    this.getList()
    // 埋点
    if (this.currentTitle) {
      setTimeout(() => {
        sa.track('ContentRepository_Paging', {
          screenType: '试卷页面',
          fiterPaging: '搜索翻页',
          pageNumber: val
        })
      }, 50)
    } else {
      setTimeout(() => {
        sa.track('ContentRepository_Paging', {
          screenType: '试卷页面',
          fiterPaging: '筛选翻页',
          pageNumber: val
        })
      }, 50)
    }
  }
  /**
   * clickNet
   */
  public clickNet(item) {
    // console.log(item)
    // this.$store.commit('SET_LOGINMODAL', true)
    this.page = 1
    if (this.userName) {
      this.currentNet = item[1]
      this.currentSite = item[0]
      switch (item[1]) {
        case '学科网':
          this.$store.commit('SET_ALLRULES', this.xueke)
          break
        default:
          this.$store.commit('SET_ALLRULES', this.grades)
          break
      }
    } else {
      if (item[0] !== 1) {
        this.clean = !this.clean
        this.$store.commit('SET_LOGINMODAL', true)
      }
    }
  }
  public clickRanger(status) {
    // console.log(status)
    switch (status) {
      case 'down':
        this.sortWay = 'desc'
        break
      case 'up':
        this.sortWay = 'asc'
        break
      default:
        break
    }
    this.getList()
  }
  // 精排卷筛选
  onVersionChange(e) {
    this.typed = e.target.checked
    // 筛选
    this.page = 1
    this.getList()
  }
  // 名校试卷筛选
  onFamousChange(e) {
    this.famousPaper = e.target.checked
    // 筛选
    this.page = 1
    this.getList()
  }
  //
  public async getList() {
    let obj = Object.assign({}, this.getFilters, {
      subject_id: ~~this.subject.value,
      title: this.currentTitle,
      page: this.page - 1,
      per_page: this.perPage,
      sort_way: this.sortWay,
      site: this.currentSite,
      is_famous_school_paper: this.famousPaper
    })
    if (this.rn) {
      obj.rn = this.rn
    }
    if (!~~this.subject.value) {
      return
    }
    if (!this.loading) {
      this.loading = true
    }
    // 是否为精排卷
    if (this.typed) {
      obj.quality = 1
    } else {
      obj.quality = undefined
    }
    let data = await paperList(obj)
    if (this.loading) {
      this.loading = false
    }
    if (!data.success) {
      // console.log(data)
      this.contentData = []
      this.total = 0
      this.sum = 0
      if (!this.judgeCode(data)) {
        return
      }
    } else {
      this.noBind = false
      if (data.data && data.data.papers) {
        this.contentData = data.data.papers
        this.total = data.data.total_count
        if (this.currentSite === 1 || this.currentSite === 6) {
          this.sum = data.data.page_count * this.perPage
        } else {
          this.sum = this.total
        }
        if (this.currentSite === 3) {
          this.perPage = data.data.per_page
        }
        if (data.data.rn) {
          this.rn = data.data.rn
        }
      } else {
        this.contentData = []
        this.total = 0
        this.sum = 0
      }
    }
  }
  public judgeCode(data) {
    let flag = false
    let urlParams = getUrlParams('?' + data.error)
    let title: any = ''
    let content: any = ''
    const h = this.$createElement
    if (data.code === 0) {
      flag = true
    } else if (data.code === 1) {
      this.noBind = false
      flag = false
    } else if (data.code === 2) {
      this.noBind = false
      this.visible = false
      this.$store.commit('SET_LOGINMODAL', true)
      flag = false
    } else if (data.code === 3) {
      this.noBind = true
      flag = false
    } else if (data.code === 4) {
      this.noBind = false
      this.visible = false
      this.testModal = true
      flag = false
    } else {
      this.noBind = false
      flag = false
    }
    return flag
  }
  public async getPaperDoc(val, val2?: any) {
    let req: any = {
      subject_id: this.subject.value,
      paper_id: val,
      site: this.currentSite
    }
    let res: any = null
    if (val2) {
      req = Object.assign({}, req, val2)
    }
    this.loadingModal = true
    let data = await paperDoc(req)
    if (data.error && data.error == '请登录') {
      this.noBind = false
      this.visible = false
      this.$store.commit('SET_LOGINMODAL', true)
    }
    this.loadingModal = false
    if (!this.judgeCode(data)) {
      return
    }
    if (!data.data.doc_src || data.data.doc_src.length <= 0) {
      if (data.data.msg) {
        this.$message.warning(data.data.msg)
      } else {
        this.$message.warning('下载地址不见了')
      }
      if (data.data && data.data.remaining_ticket_num >= 0) {
        this.youDian = {
          remaining_ticket_num: data.data.remaining_ticket_num,
          required_ticket_num: data.data.required_ticket_num,
          doc_src: ''
        }
      }
      return
    }
    // if (this.currentSite === 2) {
    //   res = await paperDocS2({
    //     doc_src: data.data.doc_src,
    //     site: this.currentSite
    //   })
    // }
    if (data.data && data.data.remaining_ticket_num >= 0) {
      this.youDian = {
        remaining_ticket_num: data.data.remaining_ticket_num,
        required_ticket_num: data.data.required_ticket_num,
        doc_src: data.data.doc_src
      }
    }
    sa.track('ContentRepository_Download', {
      action: '下载成功'
    })
    let temp =
      '/search/finish' +
      `?subject_id=${this.subject.value}&paper_id=${val}&site=${this.currentSite}`
    if (this.currentSite === 2) {
      this.currentUrl = temp + `&da=${val2.da}&df=${val2.df}&dm=${val2.dm}`
    } else {
      temp = temp + `&url=${data.data.doc_src}`
      // console.log(temp)
      setTimeout(() => {
        window.open(temp)
      }, 0)
    }
  }
}
